import {ROUTE_PRINT_BILLET} from 'constants/routes';
import ENV from 'shared/configs/environment';

export const generateBilletLink = (nossoNumero: string) => {
	return `${ENV.baseUrlPagamentos}${ROUTE_PRINT_BILLET}/${nossoNumero}`;
};
